import React, { useState } from 'react';

import whatsapp from '@/assets/images/whatsapp.png';

const FloatingActionButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className=" lg:bottom-[15%] fixed bottom-2 right-6 z-50 flex flex-col items-center">

      <div
        className={`transition-all duration-300 ease-in-out bg-black backdrop-blur-md rounded-full py-5 px-2 relative z-50 lg:-bottom-[22px] bottom-[5px] flex flex-col items-center gap-3`}
      >
        <div className="group flex items-center gap-2 relative">
          <span className="absolute right-full mr-3 text-secondary font-bold text-base px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            Live Chat
          </span>
          <button className="hover:scale-110 transition"  onClick={() => window.Tawk_API?.maximize()}>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6 text-white w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
              />
            </svg>



          </button>
        </div>

        <div className="group flex items-center gap-2 relative">
          <span className="absolute right-full mr-3 text-secondary font-bold text-base px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            WhatsApp
          </span>
          <button className="hover:scale-110 transition">
            <a href="https://api.whatsapp.com/send/?phone=918824100200&text&type=phone_number&app_absent=0" target='_blank'>
            <img src={whatsapp} alt="WhatsApp" className="w-6 h-6" /></a>
          </button>
        </div>
      </div>

    </div>

  );
};

export default FloatingActionButton;
